import config from './config'
import axios from 'axios'
import parseJSON from './readJSONFile'
import getSignedURL from './getSignedURL'

const getImageURL = async (obj) => {
  const args = {
    Prefix: obj.id,
  }

  const [url, params] = config('listObjectsV2', args)

  const key = await axios.post(url, params).then((res) => {
    if (res.data.Contents) {
      for (const i of res.data.Contents) {
        const ext = i.Key.split('.').pop()

        if (!['pdf', 'json'].includes(ext)) {
          return i.Key
        }
      }
    }
  })

  return await getSignedURL(key)
}

const getVimeoVideoImage = async (link) => {
  const vimeoId = link.split('/').pop()
  const apiUrl = `https://vimeo.com/api/v2/video/${vimeoId}.json`

  const response = await axios.get(apiUrl)

  if (response.status === 200) {
    const { data } = response

    if (data[0] && data[0].thumbnail_large) {
      return data[0].thumbnail_large
    }
  }
}

const fetchDirectory = async () => {
  const paths = [
    'media/press-release/index.json',
    'media/videos/index.json',
    'media/articles/index.json',
  ]

  // eslint-disable-next-line no-useless-catch
  try {
    let data = []

    for (const path of paths) {
      const results = await parseJSON(path)

      results.forEach((result) => {
        if (result.homeFeatured) {
          data.push(result)
        }
      })
    }

    let homeFeatured = []

    for (const j of data) {
      if (!('link' in j)) {
        const imageURL = await getImageURL(j)

        const { header, subheader, id } = j
        const obj = { header, subheader, imageURL, id }
        homeFeatured.push(obj)
      } else {
        const { link, title, description, id } = j
        const imageURL = await getVimeoVideoImage(link)
        const obj = { header: title, subheader: description, imageURL, id }
        homeFeatured.push(obj)
      }
    }

    return homeFeatured
  } catch (err) {
    throw err
  }
}

export default fetchDirectory
